import {
  beginEditorSessionRecovery,
  editorSessionFor,
  fieldEditorContextKey,
} from '@/shared/workspace/editor-sessions';

import type { FieldWorkspaceContext } from '@mio/shared';

export const fieldEditorSessionFor = (context: FieldWorkspaceContext) =>
  editorSessionFor(fieldEditorContextKey(context));

export const beginFieldEditorSessionRecovery = (context: FieldWorkspaceContext) =>
  beginEditorSessionRecovery(fieldEditorContextKey(context));
